<template>
  <section class="w-full -mb-[60px]">
    <div class="relative">
      <div
        class="max-md:hidden absolute inset-y-0 start-0 end-1/2 bg-neutral-5 pointer-events-none"
        aria-hidden="true"
      ></div>
      <div
        class="max-md:hidden absolute inset-y-0 start-1/2 end-0 bg-foundation-verde3 pointer-events-none"
        aria-hidden="true"
      ></div>
      <div class="container relative flex flex-col md:flex-row pb-6 md:pb-12">
        <div
          class="w-full md:w-1/2 px-5 md:px-7 pt-6 md:pt-16.5 pb-6 md:pb-16 bg-neutral-5 flex flex-col gap-5 md:gap-8"
        >
          <!-- Header -->
          <div class="flex flex-col gap-2 items-start">
            <h2 class="typo-h2 md:typo-h1 text-foundation-verde1">
              {{ faq.title }}
            </h2>
            <p class="typo-p2 md:typo-p1 text-foundation-verde1">
              {{ faq.description }}
            </p>
            <ButtonV2 variant="text" appearance="primary" v-bind="faq.cta" class="mt-2 md:mt-4" />
          </div>

          <!-- FAQ accordion -->
          <Faq :items="faq.items" :uppercase-questions="false" accordion-variation="separated" :multiple="false" />
        </div>

        <WaveDividerV2
          :curvature-boost="5"
          bottom-color="#009639"
          bottom-color-right="#009639"
          top-color="#F1EFE7"
          class="md:hidden"
        />

        <div
          class="w-full md:w-1/2 px-6 md:px-10 pt-10 md:pt-16.5 pb-15 md:pb-9.5 bg-foundation-verde3 flex flex-col justify-center items-center gap-8"
        >
          <div class="flex flex-col gap-2 text-center">
            <h2 class="typo-h1 text-neutral-6">
              {{ banner.title }}
            </h2>
            <p class="typo-p2 md:typo-p1 text-neutral-6 text-center">
              {{ banner.description }}
            </p>
          </div>

          <div class="relative w-[292px] h-[188px] md:h-[320px] md:w-full col-span-2 overflow-hidden rounded-2xl">
            <Carousel
              :slides-per-view="1"
              :space-between="0"
              :loop="true"
              :show-arrow="false"
              :show-dots="true"
              dots-class="absolute bottom-4 z-10 left-1/2 -translate-x-1/2 !mt-0"
              :autoplay="{ delay: 5000, disableOnInteraction: false }"
              class="h-full w-full"
            >
              <SwiperSlide v-for="(item, index) in banner.images" :key="index" class="h-full w-full">
                <NuxtImg
                  :src="item.url"
                  :alt="item.alt"
                  class="w-full h-full object-cover"
                  sizes="sm:292px md:560px lg:560px xl:560px 2xl:560px"
                  loading="lazy"
                  format="webp"
                />
              </SwiperSlide>
            </Carousel>
          </div>

          <ButtonV2
            v-if="button"
            v-bind="button"
            :appearance="button?.appearance ?? 'white'"
            size="lg"
            :class-names="{ root: 'px-8 py-4 tracking-normal' }"
            class="bg-foundation-verde4 text-foundation-verde1"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Faq from '~/components/organisms/Faq/Faq.vue'
import type { FAQ } from '~/types/faq'
import WaveDividerV2 from '~/components/atoms/WaveDividerV2/WaveDividerV2.vue'
import type { ButtonProps } from '~/components/atoms/ButtonV2'
import { ButtonV2 } from '~/components/atoms/ButtonV2'
import Carousel from '~/components/molecules/Carousel/Carousel.vue'
import { SwiperSlide } from 'swiper/vue'

const props = defineProps<{
  faq: FAQ
  banner: any
  button?: ButtonProps
}>()
</script>
